import { forwardRef } from 'react';
import { StyledSectionItem } from './styled';

const SectionItem = forwardRef((props, ref) => (
  <StyledSectionItem ref={ref} {...props} />
));

export default SectionItem;
